export const STAMINA_DESCRIPTION = `
Как много ходов длятся твои партии? Никогда не считал?
Мы посчитаем за тебя. Среднее количество ходов\nв последних 100 партиях влияет на общий балл.

10 ходов = 14
40 ходов = 57
70 ходов = 99
`;

export const TACTICS_DESCRIPTION = `
Рейтинг по решению задач.
Какой из тебя тактик?
<a href="https://id.chessopen.ru/?source=ChessRussian&back=%2Fshahmatnye-zadachi%2Fmain%2F" target="_blank" rel="noreferrer">Решай задачи и этюды и развивай этот навык.</a>

Баллы за рейтинг начисляются следующим образом:
Рейтинг до 1000 = 10
Рейтинг 1200-1300 = 50
`;

export const TACTICS_DESCRIPTION_FOR_WIDGET = `
Рейтинг по решению задач.
Какой из тебя тактик?
<a href="https://chessrussian.ru/shahmatnye-zadachi/main/">Решай задачи и этюды и развивай этот навык.</a>

Баллы за рейтинг начисляются следующим образом:
Рейтинг до 1000 = 10
Рейтинг 1200-1300 = 50
`;

export const RANK_DESCRIPTION = `
Берется наивысший рейтинг игрока на нашей платформе.
Во что ты играешь сильнее: блиц, рапид, или классику?

Баллы за рейтинг начисляются следующим образом:
Рейтинг до 1000 = 10
Рейтинг 1400 = 50
Рейтинг 2700 = 100
`;

export const EXPERIENCE_DESCRIPTION = `
Чем больше играешь, тем опытнее становишься.
За каждые 10 партий добавляется 1 балл.
Да, сыграешь 1000 партий - наберешь максимальные 100 баллов!
`;

export const EFFECTIVENESS_DESCRIPTION = `
Процент побед из всех сыгранных игроком партий.
У Магнуса Карлсена за 3818 партий 44% побед.
Какой будет у тебя?
`;

export const WINS_DESCRIPTION = `
Общее количество выигранных партий по всем партиям.
`;

export const TOTAL_RANK_DESCRIPTION = `
Среднее арифметическое от всех параметров.
`;
